import { getModulesWithContainersPath } from '~/webpack/require-context'

const requireContext = require.context(`containers/`, true, /\/vuexstore\/[^/^\\]*\.js$/)
const modules = getModulesWithContainersPath(requireContext, [key => key.replace(/\/vuexstore(\/.+?)?$/, '$1')])
export default modules
